import { useAuthentication } from "@/Slices/authenticationSlice";
import React, { useEffect } from "react";
import { useIntercom } from "react-use-intercom";
import { NavBarTopContainer } from "../CustomComponents/NavBarTopContainer";
import { NavBarSignedOut } from "../CustomComponents/NavBarSignedOut";
import { isPreprod, isProduction } from "@/Environment";
import { isDemo } from "@/Environment";
import { setUserContext } from "@freightsimple/observability/errorReporting";

const NavBar: React.FC = () => {
  const { boot } = useIntercom();
  const { isAuthenticated, user } = useAuthentication();

  useEffect(() => {
    setTimeout(() => {
      // Intercom
      if (isPreprod() || isProduction() || isDemo()) {
        if (isAuthenticated && user) {
          if (!user.email.endsWith("@freightsimple.com")) {
            boot({
              email: user.email,
              name: user.name,
              company: {
                companyId: user.companyId || "",
              },
            });
          }
        }
      }

      // Observability user context
      if (isProduction()) {
        if (isAuthenticated && user) {
          try {
            setUserContext(user.userId, user.email);
          } catch (e) {
            console.error("Error setting observability user context", e);
          }
        } else {
          boot();
        }
      }
    }, 1000);
  }, [isAuthenticated]);

  // Authenticated customers get the new ui-core top nav; logged-out visitors
  // get the matching signed-out header.
  return isAuthenticated ? <NavBarTopContainer /> : <NavBarSignedOut />;
};

export default NavBar;
